module.exports = __webpack_public_path__ + "img/OLD_logo.db4ca8ae.png";